import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { CurrencyModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: CurrencyModel })
export class CurrencyBO extends BusinessObjectBase<CurrencyModel> {
    private previousDefaultValue = false;

    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        this.configureReadonlyRules();

        if (this.model.isPersistent) {
            this.previousDefaultValue = this.model.default;
        }
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation)) {
            const violations: { property: string; violation: NonUniqueModelDataError }[] = [];
            if (sameValues(conflict.objectProperties ?? [], ['name'])) {
                violations.push({
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.currency.validation.name.server-rule-violations.non-unique-model-data-error')
                });
            }
            if (sameValues(conflict.objectProperties ?? [], ['symbol'])) {
                violations.push({
                    property: 'symbol',
                    violation: new NonUniqueModelDataError('business.currency.validation.symbol.server-rule-violations.non-unique-model-data-error')
                });
            }
            this.addExternalRuleViolations({
                [this.model.sun]: violations
            });
        }
    }

    private configureReadonlyRules(): void {
        this.readonly.addRule(
            [[CurrencyModel, 'default']],
            _ => this.previousDefaultValue
        );
    }
}
